import { render } from "./course-exam.vue?vue&type=template&id=fa185b82&scoped=true"
import script from "./course-exam.vue?vue&type=script&lang=js"
export * from "./course-exam.vue?vue&type=script&lang=js"

import "./course-exam.vue?vue&type=style&index=0&id=fa185b82&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa185b82"]])

export default __exports__